import { createSlice } from '@reduxjs/toolkit';

import { IFilterKeyValue } from 'common/api/type-def';
import { IAdvancedFilterValueOptions } from 'common/components/Filters/AdvancedFilters';

import { DATA_VALIDATTION_STAGE } from '../../constants/DataIngestionConstants';

import type { PayloadAction } from '@reduxjs/toolkit';

export interface IfileUploadDefaultState {
	fileMappingData: any;
	stagingTableData: any[];
	allStagingTableData: any[];
	updatedStagingData: any[];
	fileFullName: string;
	tabIndex: number;
	selectedDataValidationFileInfo: any;
	uploadedFileInfo: any;
	retainSearchText: any;
	dataIngestionFilterKeys: IAdvancedFilterValueOptions[];
	dataIngestionSelectedFilterKeys: IFilterKeyValue[];
	showAssignedMeChecked: boolean;
	parsedFileInfo: string;
}

const {
	DATA_VALIDATION_VALID_STATUS,
	DATA_VALIDATION_INVALID_STATUS,
	DATA_VALIDATION_DUPLICATE_STATUS,
} = DATA_VALIDATTION_STAGE;

const initialState: IfileUploadDefaultState = {
	fileMappingData: {},
	stagingTableData: [],
	allStagingTableData: [],
	updatedStagingData: [],
	fileFullName: '',
	tabIndex: 0,
	selectedDataValidationFileInfo: {},
	uploadedFileInfo: {},
	retainSearchText: '',
	dataIngestionFilterKeys: [],
	dataIngestionSelectedFilterKeys: [],
	showAssignedMeChecked: false,
	parsedFileInfo: '',
};

export const dataIngestionSlice = createSlice({
	name: 'dataingestion',
	initialState,
	reducers: {
		setFileMappingData: (state, action: PayloadAction<any>) => {
			state.fileMappingData = action.payload;
		},
		setStagingTableData: (state, action: PayloadAction<any[]>) => {
			state.stagingTableData = action?.payload;
		},
		setAllStagingTableData: (state, action: PayloadAction<any[]>) => {
			state.allStagingTableData = action?.payload;
		},
		setEditedFileFullName: (state, action: PayloadAction<string>) => {
			state.fileFullName = action?.payload;
		},
		setSearchStagedData: (state, action: PayloadAction<any[]>) => {
			state.stagingTableData = [];
			state.stagingTableData = action?.payload;
		},
		setUpdatedStagedData: (state, action: PayloadAction<any[]>) => {
			state.updatedStagingData = action?.payload;
		},
		setValidStagedData: (state, action: PayloadAction<any[]>) => {
			const tempdata = action?.payload;
			const staggedData = tempdata.filter(
				(ele: any) =>
					ele?.validationStatus?.toLowerCase() === DATA_VALIDATION_VALID_STATUS,
			);
			state.stagingTableData = staggedData;
		},
		setInValidStagedData: (state, action: PayloadAction<any[]>) => {
			const tempdata = action?.payload;
			const staggedData = tempdata.filter(
				(ele: any) =>
					ele?.validationStatus.toLowerCase() ===
					DATA_VALIDATION_INVALID_STATUS,
			);
			state.stagingTableData = staggedData;
		},
		setDuplicatesStagedData: (state, action: PayloadAction<any[]>) => {
			const tempdata = action?.payload;
			const staggedData = tempdata.filter(
				(ele: any) =>
					ele?.validationStatus.toLowerCase() ===
					DATA_VALIDATION_DUPLICATE_STATUS,
			);
			state.stagingTableData = staggedData;
		},
		setAllStagedData: (state, action: PayloadAction<any[]>) => {
			state.stagingTableData = action?.payload;
		},
		setTabIndex: (state, action: PayloadAction<number>) => {
			state.tabIndex = action?.payload;
		},
		setSelectedDataValidationFileInfo: (
			state,
			action: PayloadAction<number>,
		) => {
			state.selectedDataValidationFileInfo = action?.payload;
		},
		setUploadedFileInfo: (state, action: PayloadAction<any>) => {
			state.uploadedFileInfo = action?.payload;
		},
		setRetainSearchText: (state, action: PayloadAction<string>) => {
			state.retainSearchText = action?.payload;
		},
		setDataIngestionFilterKeys: (state, action: PayloadAction<any>) => {
			state.dataIngestionFilterKeys = action?.payload;
		},
		setDataIngestionSelectedFilterKeys: (state, action: PayloadAction<any>) => {
			state.dataIngestionSelectedFilterKeys = action?.payload;
		},
		setDataIngestionAssignedToMeChecked: (
			state,
			action: PayloadAction<boolean>,
		) => {
			state.showAssignedMeChecked = action?.payload;
		},
		setParseFileData: (state, action: PayloadAction<string>) => {
			state.parsedFileInfo = action?.payload;
		},
	},
});

export const {
	setFileMappingData,
	setStagingTableData,
	setAllStagingTableData,
	setEditedFileFullName,
	setSearchStagedData,
	setUpdatedStagedData,
	setValidStagedData,
	setInValidStagedData,
	setDuplicatesStagedData,
	setTabIndex,
	setSelectedDataValidationFileInfo,
	setUploadedFileInfo,
	setRetainSearchText,
	setDataIngestionFilterKeys,
	setDataIngestionSelectedFilterKeys,
	setDataIngestionAssignedToMeChecked,
	setParseFileData,
} = dataIngestionSlice.actions;
export default dataIngestionSlice.reducer;
